import { render, staticRenderFns } from "./carouselManagement.vue?vue&type=template&id=655fbd3f&"
import script from "./carouselManagement.vue?vue&type=script&lang=js&"
export * from "./carouselManagement.vue?vue&type=script&lang=js&"
import style0 from "./carouselManagement.vue?vue&type=style&index=0&id=655fbd3f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports